import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { ImagePicker } from 'containers/misc'
import { MaterialModal } from 'components/layout'
import { Note } from 'components/misc'
import { Textarea } from 'components/fields'
import { form } from 'helpers/decorators'
import validate from './already-assessed.validation'

@form({
  form: 'sendAlreadyAssessed',
  disableHook: true,
  validate
})
@connect(({ api }) => ({
  isFileUploading: api.blob.loading
}))
class AlreadyAssessed extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
    reset: PropTypes.func,
    colorClass: PropTypes.string,
    isFileUploading: PropTypes.bool,
    isAJ: PropTypes.bool
  }

  handleSubmit = fields =>
    this.props.onSubmit(fields, { resetForm: this.props.reset })

  render() {
    const {
      loading,
      colorClass,
      handleSubmit,
      isFileUploading,
      isAJ
    } = this.props
    const intl = `label.you_have_finished${isAJ
      ? '_aj'
      : ''}_now_send_to_approval`

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Note margin="0 0 30px">
          <FormattedMessage
            id={intl}
            defaultMessage="You have finished. Now you can send to your Assessor to approval."
          />
        </Note>

        <Textarea
          name="note"
          label="Note for Leader"
          intlKey="label.note_for_leader"
          optional
        />

        <ImagePicker name="files" isFile />

        <MaterialModal.Footer
          action="Send for approval"
          actionKey="button.send_for_approval"
          colorClass={colorClass}
          insideContent
          isLoading={loading}
          disabled={isFileUploading}
        />
      </form>
    )
  }
}

export default AlreadyAssessed
